module.exports = __webpack_public_path__ + "img/clouds.4af387a0.jpg";